import {
  IonButton,
  IonButtons,
  IonIcon,
  IonSearchbar,
  IonToolbar,
  IonBadge,
} from '@ionic/react';
import { FunctionComponent } from 'react';
import { closeOutline } from 'ionicons/icons';
import DynamicButton from 'components/buttons/DynamicButton';
import { pad } from 'lodash';

interface ToolbarProps {
  openFilterModal: () => void;
  searchTerm: string;
  onSearch: (event: CustomEvent) => void;
  onClearSearch: () => void;
  hasActiveFilters: boolean;
  onClearFilters: () => void;
  onOpenCreateModal?: () => void;
}

const Toolbar: FunctionComponent<ToolbarProps> = ({
  openFilterModal,
  searchTerm,
  onSearch,
  onClearSearch,
  hasActiveFilters,
  onClearFilters,
  onOpenCreateModal,
}) => {
  return (
    <IonToolbar className="notchSafe">
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          backgroundColor: 'transparent',
          color: 'transparent',
        }}
      >
        <div className="searchbar-wrapper">
          <IonSearchbar
            className="white-searchbar-ios"
            style={
              {
                '--background': 'white',
                '--color': 'black',
                '--placeholder-color': '#666',
                '--icon-color': '#666',
                '--clear-button-color': '#666',
              } as React.CSSProperties
            }
            value={searchTerm}
            onIonInput={onSearch}
            onIonClear={onClearSearch}
            placeholder="Suchen..."
            showClearButton="focus"
          />
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <IonButtons>
            <DynamicButton
              isToggleable
              iconName="FilterDownIcon"
              iconNameToggle="FilterUpIcon"
              buttonType="icon-full"
              size="xlarge"
              fill="clear"
              toggled={hasActiveFilters}
              onClick={hasActiveFilters ? onClearFilters : openFilterModal}
              text={undefined}
            />
          </IonButtons>
          {onOpenCreateModal && (
            <IonButtons>
              <DynamicButton
                iconName="AddUpIcon"
                buttonType="icon-full"
                size="xlarge"
                fill="clear"
                onClick={onOpenCreateModal}
                text="Erstellen"
              />
            </IonButtons>
          )}
        </div>
      </div>
    </IonToolbar>
  );
};

export default Toolbar;
